import React, { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import "../../../scss/common.scss";
import { useStateContext } from "state";
import { Dashboard as AdHocDashboard } from "features/ad-hoc-dashboard/dashboard";
import { useAccountQuicksight } from "../../../hooks/quicksight/useAccountQuicksight.ts";
import { IFrame } from "core/components/iframe/index.ts";

const AccountDashboardPage: React.FC = () => {
  const { id, contextId } = useParams();

  const [searchParams] = useSearchParams();
  const ctx = searchParams.get("ctx") || contextId;
  const state = useStateContext();

  const role = useMemo(() => {
    return state.user?.roles.find((value) => value.accountNumber === id);
  }, [state.user]);

  const result = useAccountQuicksight({ account_number: id! });

  if (role?.isAdhoc && ctx) {
    return <AdHocDashboard contextId={ctx} />;
  }

  return <IFrame.Query query={result} />;
};

export default AccountDashboardPage;
